import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import EventListener from "react-event-listener";
import QRCode from "qrcode.react";

import AppBar from "@material-ui/core/AppBar";
import Drawer from "@material-ui/core/Drawer";
import Toolbar from "@material-ui/core/Toolbar";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import MenuIcon from "@material-ui/icons/Menu";
import FavoriteIcon from "@material-ui/icons/Favorite";
import OrderHistoryIcon from "@material-ui/icons/History";
import SearchIcon from "@material-ui/icons/SearchRounded";
import BackIcon from "@material-ui/icons/KeyboardArrowLeftRounded";
import ClearIcon from "@material-ui/icons/ClearRounded";
import CheckIcon from "@material-ui/icons/CheckCircleRounded";
import LocationIcon from "@material-ui/icons/LocationOn";
import HomeIcon from "@material-ui/icons/HomeRounded";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import CuisinesIcon from "../assets/images/cusine.svg";
import ClockIcon from "../assets/images/timing.svg";
import ReceiptIcon from "../assets/images/receipt.svg";
import EmptyFilter from "../assets/images/empty_filter_mobile.svg";
import SelectedFilter from "../assets/images/selected_filter_mobile.svg";
import classnames from "classnames";
import Divider from "@material-ui/core/Divider";
import EventIcon from "@material-ui/icons/Event";
import { setErrorMessage } from "../store/actionCreators/errorMessage";

import {
  QUICK_TAB_OPTIONS,
  APPBAR_HEIGHT,
  GENERAL_ERROR_MSG
} from "../utils/Constants";
import {
  IS_SAME_FILTER,
  GET_DISPLAY_NAME,
  getFormattedTimings,
  closeAllDialogs,
  FORM_FEEDBACK_URL
} from "../utils/CommonFunctions";
import postJSON from "../utils/PostJSON";
import {
  WELCOME_PAGE_URL,
  DASHBOARD_PAGE_URL,
  SETTING_PAGE_URL,
  RESTAURANT_PAGE_URL,
  PRE_BOOK_URL
} from "../utils/Route";
import {
  BASE_URL,
  GET_USER_FOOD_COURTS,
  LOGOUT,
  PROFILE_PIC_STORAGE_URL,
  ORDER_HISTORY
} from "../utils/Urls";

import { clearUserDetails } from "../store/actionCreators/userDetails";
import { setFilters } from "../store/actionCreators/filters";
import { reduceMenuList } from "../store/actionCreators/menuList";
import AccountCircleIcon from "@material-ui/icons/AccountCircleRounded";
import {
  setSearchText,
  clearSearchText
} from "../store/actionCreators/searchText";
import storeFoodCourtsList from "../store/actionCreators/foodCourtsList";
import { clearFoodNRecURLS } from "../store/actionCreators/saveFoodNRecURLS";

// import picture from "../assets/images/sampleUser.png";
import { FoodBookLogo } from "../utils/Constants";
import foodbookTheme from "../hoc/Theme";
import {
  MuiThemeProvider,
  Button,
  Checkbox,
  Backdrop
} from "@material-ui/core";

import DashboardDesktopHeader from "./DashboardDesktopHeader";
import SettingsDesktopHeader from "./Settings/SettingsDesktopHeader";
import { Grid } from "@material-ui/core";

import SwitchRestaurantModal from "./Dashboard/switchRestaurant";
import { WELCOME_PAGE } from "../utils/Colors";
import FeedbackIndicator from "./Dashboard/FeedbackIndicator";
import FilterDropdown from "./Dashboard/FilterDropdown";
import GlobalSearch from "./AppBar/GlobalSearch";
import RestSearch from "./AppBar/RestSearch";
import {
  setSearchNotify,
  clearSearchNotify
} from "../store/actionCreators/searchNotify";
import storeFoodCourtDetails from "../store/actionCreators/currentFoodCourtDetails";

const drawerWidth = 280;

const classes = theme => ({
  appBarRoot: {
    backgroundColor: "#F37020",
    zIndex: theme.zIndex.drawer + 1,
    height: APPBAR_HEIGHT.mobile,
    [theme.breakpoints.down("sm")]: {
      zIndex: "9999"
    }
  },
  appBarRootTransparent: {
    zIndex: theme.zIndex.drawer + 1,
    height: "60px",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  appBar: {
    position: "fixed",
    marginLeft: drawerWidth
  },
  userDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "10rem",
    backgroundColor: "white"
  },
  Logo: {
    height: "40px",
    marginTop: "15px",
    marginLeft: "10px"
  },
  displayPicture: {
    borderRadius: "50%",
    overflow: "hidden",
    height: "75px",
    width: "75px"
  },
  drawerPaper: {
    position: "relative",
    width: drawerWidth,
    backgroundColor: "#F7F7F7"
  },
  navIcon: {
    width: "40px",
    color: "white",
    height: APPBAR_HEIGHT.mobile
  },
  title: {
    margin: "auto"
  },
  SearchBox: {
    // borderBottom: "1px solid white",
    color: "white",
    padding: "10px",
    width: "90%",
    boxSizing: "border-box"
  },
  Underline: {
    "&:before": {
      borderBottom: "1px solid white"
    },
    "&:after": {
      borderBottom: "1px solid white"
    },
    "&:focus": {
      borderBottom: "1px solid white"
    }
  },
  Center: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)"
  },
  SearchBox: {
    // borderBottom: "1px solid white",
    color: "white",
    padding: "10px",
    width: "90%",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  },
  LocationText: {
    margin: "0px",
    fontSize: "1rem",
    display: "inline-block",
    position: "absolute",
    top: "50%",
    width: "90%",
    left: "50%",
    overflow: "hidden",
    // height: "1rem",
    transform: "translate(-50%,-50%)",
    cursor: "pointer",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  Filler: {
    height: APPBAR_HEIGHT.desktop,
    [theme.breakpoints.down("sm")]: {
      height: APPBAR_HEIGHT.mobile
    }
  },
  Dot: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    right: "10%",
    height: "8px",
    width: "8px",
    backgroundColor: "white",
    borderRadius: "50px"
  },
  SelectButton: {
    color: "#F37020",
    borderColor: "#F37020",
    borderRadius: "50px",
    marginRight: "5px",
    fontSize: "10px",
    padding: "5px 5px",
    minHeight: "0px"
  },
  FoodCourtCardItem: {
    margin: "7px 0px !important"
  },
  FilterStyle: {
    height: "24px",
    width: "24px"
  },
  FullWidthContainer: {
    paddingRight: "0px",
    paddingLeft: "0px"
  },
  FullWidthLabel: {
    width: "100%",
    margin: "0px",
    paddingRight: "16px"
  },
  FoodcourtLabel: {
    position: "absolute",
    // bottom: "0px",
    right: "5px",
    top: "2px",
    paddingBottom: "3px"
  },
  offerTextRoot: {
    position: "absolute",
    top: "10px",
    left: "-7px",
    // display: "flex",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "45%"
    },
    height: "25px"
  },
  offerTextRootWithImage: {
    position: "absolute",
    top: "10px",
    left: "-7px",
    // display: "flex",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "65%"
    },
    height: "25px"
  },
  offerTextMainContainer: {
    display: "flex"
  },
  offerTextContainer: {
    width: "90%",
    height: "20px",
    backgroundColor: WELCOME_PAGE.primaryColor,
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    paddingLeft: "7px",
    fontSize: "11px",
    // fontWeight: "bold",
    color: "white",
    boxShadow: "4px 2px 4px 0px rgba(0, 0, 0, 0.5)",
    borderRadius: "2px 0 0 0"
  },
  TopCut: {
    width: 0,
    height: 0,
    borderRight: "10px solid transparent",
    borderTop: `10px solid ${WELCOME_PAGE.primaryColor}`
    // boxShadow: "4px 2px 4px 0px rgba(0, 0, 0, 0.5)"
  },
  BottomCut: {
    width: 0,
    height: 0,
    borderRight: "10px solid transparent",
    borderBottom: `10px solid ${WELCOME_PAGE.primaryColor}`
    // boxShadow: "4px 2px 4px 0px rgba(0, 0, 0, 0.5)"
  },
  BottomEdge: {
    width: 0,
    height: 0,
    borderLeft: `7px solid transparent`,
    borderTop: "7px solid #bd5b20"
  },
  InputIcon: {
    color: "white",
    paddingTop: "10px"
  }
});

const filterOptions = [
  {
    label: "Veg",
    option: "V"
  },
  {
    label: "Egg",
    option: "E"
  },
  {
    label: "Non-Veg",
    option: "N"
  }
];

const SIDEBAR_CONTENT = [
  {
    label: "Home",
    route: "home",
    icon: HomeIcon
  },
  ...QUICK_TAB_OPTIONS
];

const DialogStyles = {
  RestaurantDialog: { maxWidth: "350px" },
  RestaurantTitle: { fontWeight: "500" },
  DetailsTitle: { fontWeight: "bold", padding: "10px 0px" },
  DetailsContent: { padding: "0px 10px" },
  RestaurantCard: { margin: "0px", boxShadow: "none" },
  DetailsWrapper: { display: "block", padding: "8px 24px 8px" },
  OtherLocation: {
    padding: "5px 5px",
    backgroundColor: "#f0f0f0",
    fontWeight: "bold"
  },
  Icon: { color: "#757575", marginRight: "10px" },

  SvgIcon: {
    color: "#757575",
    marginRight: "10px",
    height: "16px",
    width: "16px",
    opacity: "0.60"
  },
  SelectIcon: { color: "#F37020" },
  RestaurantWrapper: { padding: "0px" },
  Wrapper: { padding: "0px 16px", minHeight: "0px" },
  FoodCourtWrapper: { paddingBottom: "10px" },
  DetailsText: {
    fontSize: "14px",
    textOverflow: "ellipsis",
    overflow: "hidden"
  },
  VerticalCenter: {
    display: "flex",
    alignItems: "center"
  }
};

const FoodCourtCard = props => {
  const {
    data,
    classes,
    dialogStyles,
    item,
    clickHandler,
    onChange,
    currentOpenPanel
  } = props;
  const {
    RestaurantCard,
    RestaurantTitle,
    DetailsTitle,
    DetailsContent,
    DetailsWrapper,
    OtherLocation,
    Icon,
    SvgIcon,
    SelectIcon,
    Wrapper,
    RestaurantWrapper,
    FoodCourtWrapper,
    DetailsText,
    VerticalCenter
  } = dialogStyles;

  let formattedRestaurant = [];
  (item["restaurantlist"] || []).map(item => {
    formattedRestaurant.push(item["restname"]);
  });
  formattedRestaurant = formattedRestaurant.join(", ");

  return (
    <ExpansionPanel
      style={RestaurantCard}
      onChange={onChange(item.id)}
      expanded={currentOpenPanel === item.id}
    >
      <ExpansionPanelSummary
        style={Wrapper}
        classes={{ content: data.classes.FoodCourtCardItem }}
      >
        <Grid container style={RestaurantWrapper}>
          <Grid item xs style={VerticalCenter}>
            <Typography style={RestaurantTitle}>{item.name}</Typography>
          </Grid>
          <Grid item>
            {clickHandler ? (
              <Button
                variant="outlined"
                className={data.classes.SelectButton}
                onClick={clickHandler(item)}
              >
                select
              </Button>
            ) : (
              <CheckIcon style={SelectIcon} />
            )}
          </Grid>
        </Grid>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={DetailsWrapper}>
        {item.address && (
          <Grid container style={FoodCourtWrapper}>
            <Grid item>
              <LocationIcon style={Icon} />
            </Grid>
            <Grid item xs style={DetailsText}>
              {item.address}
            </Grid>
          </Grid>
        )}
        {item["starttime"] && item["endtime"] && (
          <Grid container style={FoodCourtWrapper}>
            <Grid item>
              <img src={ClockIcon} style={SvgIcon} />
            </Grid>
            <Grid item xs style={DetailsText}>
              {getFormattedTimings(`${item.starttime}-${item.endtime}`)}
            </Grid>
          </Grid>
        )}
        {formattedRestaurant && (
          <Grid container style={FoodCourtWrapper}>
            <Grid item>
              <img src={CuisinesIcon} style={SvgIcon} />
            </Grid>
            <Grid item xs style={DetailsText}>
              {formattedRestaurant}
            </Grid>
          </Grid>
        )}
        {item.orderingchannels && (
          <Grid container style={FoodCourtWrapper}>
            <Grid item>
              <img src={ReceiptIcon} style={SvgIcon} />
            </Grid>
            <Grid item xs style={DetailsText}>
              {item.orderingchannels}
            </Grid>
          </Grid>
        )}
      </ExpansionPanelDetails>
      <Divider />
    </ExpansionPanel>
  );
};
const HomeIconStyles = { width: "0px", padding: "5px" };

const DrawerContent = props => {
  const {
    classes,
    history,
    close,
    logoutHandler,
    userDetails,
    hideLogout,
    foodCourtDetails
  } = props;
  // const feedbackURL = FORM_FEEDBACK_URL(); // CX was not removed
  const feedbackURL = "";

  let clickHandler = route => {
    close();

    if (route === "home") {
      history.push(DASHBOARD_PAGE_URL);
      return;
    }
    if (route === "prebook") {
      history.push(PRE_BOOK_URL);
      return;
    }

    if (route === "logout") {
      logoutHandler();
      return;
    }

    history.push(`${SETTING_PAGE_URL}/${route}`);
  };

  // let getDisplayName = () => {
  //   const { userid, name, employeeid } = userDetails;
  //   let possibleNameToBeDisplayed = [name, employeeid, userid];

  //   for (let value of possibleNameToBeDisplayed) {
  //     if (typeof value === "string" && value.trim() !== "") {
  //       return value;
  //     }
  //   }
  // };

  if (
    foodCourtDetails.extras.extras.ordertypes.preorder &&
    (foodCourtDetails.extras.extras.slots_enabled ||
      foodCourtDetails.extras.extras.ordering_enabled) &&
    SIDEBAR_CONTENT[1].label !== "Pre-Booking"
  ) {
    SIDEBAR_CONTENT.splice(1, 0, {
      label: "Pre-Booking",
      route: "prebook",
      icon: EventIcon
    });
  }

  if (
    !foodCourtDetails.extras.extras.slots_enabled &&
    !foodCourtDetails.extras.extras.ordering_enabled &&
    SIDEBAR_CONTENT[1].label === "Pre-Booking"
  ) {
    SIDEBAR_CONTENT.splice(1, 1);
  }

  if (
    !foodCourtDetails.extras.extras.ordertypes.preorder &&
    SIDEBAR_CONTENT[1].label === "Pre-Booking"
  ) {
    SIDEBAR_CONTENT.splice(1, 1);
  }
  return (
    <div>
      <div className={classes.Filler} />
      <div className={classes.userDetail}>
        <div>
          {feedbackURL ? (
            <QRCode value={feedbackURL} style={{ padding: 8, marginTop: 8 }} />
          ) : userDetails.profile_picture ? (
            <img
              width="75px"
              height="75px"
              src={PROFILE_PIC_STORAGE_URL + userDetails.profile_picture}
              style={{ borderRadius: 50 }}
            />
          ) : (
            <AccountCircleIcon
              className={classes.displayPicture}
              style={{ color: "black" }}
            />
          )}
          {/* <img src={picture} width="75" height="75" className={classes.displayPicture} /> */}
        </div>
        {!feedbackURL ? (
          <Typography variant="subheading" style={{ color: "black" }}>
            {/* {getDisplayName()} */}
            {GET_DISPLAY_NAME(userDetails)}
          </Typography>
        ) : null}
      </div>
      <List>
        {SIDEBAR_CONTENT.map(content => {
          if (content.route == "logout" && hideLogout) {
            return null;
          }
          return (
            <React.Fragment key={content.route}>
              <ListItem
                button
                onClick={() => {
                  clickHandler(content.route);
                }}
                style={{
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  paddingRight:
                    content.route === "foodbook_wallet" ? "0px" : "16px"
                }}
              >
                <ListItemIcon>
                  <content.icon
                    style={{ color: "black", marginRight: "0px" }}
                  />
                </ListItemIcon>
                <ListItemText
                  style={{
                    color: "black",
                    position: "relative",
                    paddingRight:
                      content.route === "foodbook_wallet" ? "0px" : "16px"
                  }}
                >
                  {content.label}
                  {content.route === "foodbook_wallet" &&
                    userDetails.ecash >= 0 && (
                      <span style={{ position: "absolute", right: "5px" }}>
                        {"₹" + userDetails.ecash.toFixed(2)}
                      </span>
                    )}
                </ListItemText>
              </ListItem>
              <Divider style={{ backgroundColor: "black" }} />
            </React.Fragment>
          );
        })}
      </List>
    </div>
  );
};

class AppBarAndDrawer extends Component {
  constructor(props) {
    super(props);
    let currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    // if (Object.keys(currentFoodCourt).length === 0)
    //   this.props.history.push("/");
    // currentFoodCourt = JSON.parse(currentFoodCourt);

    this.state = {
      openDrawer: false,
      filterAnchorEl: null,
      searchText: props.searchText,
      searchBarShow: props.searchText !== "",
      userFoodCourts: [],
      dialogState: props.showFoodcourtListing || false,
      currentFoodCourt: currentFoodCourt.label,
      currentFoodCourtId: currentFoodCourt.value,
      currentExpandedFoodCourt: "",
      switchRestaurant: false,
      touchFeature: false,
      filterDialogState: false
    };

    this.timeoutRef = null;
    this.fetchUserFoodCourts();
  }

  storeRecentOrderIDs = () => {
    let orderDetails =
      JSON.parse(localStorage.getItem("recentOrderDetails")) || {};
    if (Object.keys(orderDetails).length == 0) {
      postJSON(
        BASE_URL + ORDER_HISTORY,
        {},
        response => {
          const result = response.result;
          const extras = response.extras;
          if (result === "success") {
            const orderHistory = extras.details || [];
            if (orderHistory.length == 0) return;
            let recentTimestamp = "";
            let orderidArr = [];
            for (let i = 0; i < orderHistory.length; i++) {
              const orderObj = orderHistory[i];
              const { orderid, timestamp, orderstatus } = orderObj;
              if (orderstatus == "FAILED") continue;
              if (orderidArr.length == 0) recentTimestamp = timestamp;
              if (recentTimestamp != timestamp) {
                break;
              }
              orderidArr.push(orderid);
            }
            if (orderidArr.length > 0) {
              orderDetails = { orderids: orderidArr };
              localStorage.setItem(
                "recentOrderDetails",
                JSON.stringify(orderDetails)
              );
            }
          }
        },
        error => {
          console.log("error", error);
        }
      );
    }
  };

  componentDidMount() {
    this.storeRecentOrderIDs();
  }

  fetchUserFoodCourts = () => {
    let currentFoodCourt =
      JSON.parse(localStorage.getItem("currentFoodCourt")) || {};
    // currentFoodCourt = JSON.parse(currentFoodCourt);
    currentFoodCourt = currentFoodCourt.value;
    postJSON(
      BASE_URL + GET_USER_FOOD_COURTS,
      {
        foodcourtid: currentFoodCourt
      },
      response => {
        const userFoodCourts = response.extras.details;
        this.setState({ userFoodCourts });
        this.props.storeFoodCourtsList(userFoodCourts);
      },
      error => {
        this.props.setAlertPopup(
          (error.extras || {}).message || GENERAL_ERROR_MSG
        );
      }
    );
  };

  handleDrawerToggle = () => {
    this.setState({ openDrawer: !this.state.openDrawer });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  logoutHandler = () => {
    postJSON(
      BASE_URL + LOGOUT,
      {},
      response => {},
      error => {
        console.log((error.extras || {}).message || GENERAL_ERROR_MSG);
      }
    );
    localStorage.clear();
    this.props.history.replace(WELCOME_PAGE_URL);
    this.props.resetApp();
  };

  handleFilterMenu = event => {
    this.setState({
      filterAnchorEl: event.currentTarget,
      filterDialogState: true
    });
  };

  handleFilterMenuClose = event => {
    this.setState({
      filterAnchorEl: null,
      touchFeature: false,
      filterDialogState: false
    });
  };

  showSearchBar = () => {
    this.setState({ searchBarShow: true });
  };

  noDetailsAlertHandler = () => {
    this.props.setAlertPopup("No details present.");
  };

  searchItemClick = item => {
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      servingTime,
      isBuffet,
      allergens
    } = this.props;

    const restaurantId = item.items[0].split(":").slice(0, 2).join(":");
    this.props.searchForText(immutableMenuList, {
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      servingTime,
      isBuffet,
      allergens,
      searchId: item,
      searchText: ""
    });
    this.props.history.push("/restaurant/" + restaurantId);
  };

  searchTextOnChange = event => {
    const newSearchText = event.target.value;
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      searchId,
      servingTime,
      isBuffet,
      searchText,
      allergens
    } = this.props;
    this.setState({ searchText: newSearchText });
    this.props.clearSearchNotify();

    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      if (newSearchText.length > 2) {
        this.setState({ searchBarShow: true });
        this.props.searchForText(immutableMenuList, {
          immutableSubMenu,
          currentSession,
          filters,
          restaurantIsAlive,
          selectedDate,
          searchId,
          servingTime,
          isBuffet,
          allergens,
          searchText: newSearchText
        });
      } else {
        this.props.clearSearchText(immutableMenuList, {
          immutableSubMenu,
          currentSession,
          filters,
          restaurantIsAlive,
          selectedDate,
          servingTime,
          searchId,
          isBuffet,
          searchText: "",
          allergens
        });
      }
    }, 350);
  };

  clearSearch = () => {
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      servingTime,
      searchId,
      isBuffet,
      searchText
    } = this.props;
    this.setState({ searchText: "", searchBarShow: false });
    this.props.clearSearchNotify();
    this.props.clearSearchText(immutableMenuList, {
      immutableSubMenu,
      currentSession,
      filters,
      restaurantIsAlive,
      selectedDate,
      searchId,
      servingTime,
      isBuffet,
      searchText: ""
    });
  };

  handleDialogClose = () => {
    this.setState({ dialogState: false });
    this.props.closeFoodcourtListing();
  };

  selectFoodCourt = () => {
    if (this.props.disableLocationSelection) {
      return;
    }
    let { currentFoodCourtId } = this.state;
    if (this.state.userFoodCourts.length <= 0) {
      this.props.setAlertPopup("No Details Present.");
      return;
    }
    this.setState({
      dialogState: true,
      currentExpandedFoodCourt: currentFoodCourtId
    });
  };

  handleListItemClick = foodCourt => event => {
    event.stopPropagation();
    this.props.clearFoodNRecURLS();

    let currentFoodCourt = {
      label: foodCourt.name,
      value: foodCourt.id
    };

    if (currentFoodCourt.value === this.state.currentFoodCourtId) {
      this.handleDialogClose();
      return;
    }
    this.clearSearch();
    this.props.storeFoodCourtDetails(null);

    localStorage.setItem("currentFoodCourt", JSON.stringify(currentFoodCourt));
    this.props.history.push(DASHBOARD_PAGE_URL, {
      foodCourt: currentFoodCourt
    });
    this.handleDialogClose();
  };

  handlePanel = foodCourt => (event, expanded) => {
    event.stopPropagation();
    let { currentFoodCourtId } = this.state;
    if (foodCourt !== currentFoodCourtId) {
      this.setState({ currentExpandedFoodCourt: foodCourt });
    } else {
      this.setState({ currentExpandedFoodCourt: expanded ? foodCourt : "" });
    }
  };

  getLocationTitle = location => {
    const { pathname } = location;
    if (pathname.includes("cafepass")) {
      return "Cafe Pass";
    }

    let splitLocation = pathname.split("/");
    if (splitLocation.length === 3) {
      if ("/" + splitLocation[1] === SETTING_PAGE_URL) {
        for (let i = 0; i < QUICK_TAB_OPTIONS.length; i++) {
          if (QUICK_TAB_OPTIONS[i].route === splitLocation[2]) {
            return QUICK_TAB_OPTIONS[i].label;
          }
        }
      }
    }

    return "";
  };

  isRestaurant = location => {
    const { pathname } = this.props.location;
    return pathname.indexOf(RESTAURANT_PAGE_URL) === 0;
  };

  gotoDashboard = () => {
    this.props.history.push(DASHBOARD_PAGE_URL);
  };

  isChecked = option => {
    const { filters } = this.props;
    let found = filters.some(currentOption => currentOption === option);
    return found;
  };

  handleCheckBoxChange = option => event => {
    const {
      immutableMenuList,
      immutableSubMenu,
      currentSession,
      filters,
      servingTime,
      searchText,
      restaurantIsAlive,
      selectedDate,
      isBuffet,
      allergens
    } = this.props;
    let newFilters = [...filters];

    if (!newFilters.includes(option)) {
      newFilters.push(option);
    } else {
      let index = newFilters.indexOf(option);
      if (index > -1) {
        newFilters.splice(index, 1);
      }
    }

    this.props.changeFilter(immutableMenuList, {
      immutableSubMenu,
      selectedDate,
      searchText,
      servingTime,
      currentSession,
      restaurantIsAlive,
      filters: newFilters,
      isBuffet,
      allergens
    });
  };

  triggerOnTouchEvent = () => {
    this.handleFilterMenuClose();
  };

  switchRestaurant = () => {
    const { switchRestaurant } = this.state;
    this.props.clearSearchNotify();
    this.setState({ switchRestaurant: !switchRestaurant });
  };

  isFilterSelected = () => {
    const { filters, allergens, immutableAllergens } = this.props;
    if (
      immutableAllergens.length !== 0 &&
      immutableAllergens.length !== allergens.length
    ) {
      return true;
    }

    if (!IS_SAME_FILTER(["V", "E", "N"], filters)) {
      return true;
    }

    return false;
  };

  render() {
    const {
      classes,
      theme,
      userDetails,
      pageLocation,
      showHome,
      hideSearchBar,
      restaurantName,
      showLocation,
      hideLocationChange,
      location,
      filters,
      disableLocationSelection,
      restaurants,
      foodCourtDetails,
      isDashboard,
      foodCourtSettings,
      slotShow
    } = this.props;
    const {
      SearchBox,
      Underline,
      Center,
      LocationText,
      Filler,
      SelectButton,
      Dot,
      FilterStyle,
      FullWidthContainer,
      FullWidthLabel,
      FoodcourtLabel,
      offerTextRoot,
      offerTextRootWithImage,
      offerTextMainContainer,
      offerTextContainer,
      TopCut,
      BottomCut,
      BottomEdge
    } = classes;

    const {
      filterAnchorEl,
      searchText,
      searchBarShow,
      userFoodCourts,
      dialogState,
      currentFoodCourt,
      currentFoodCourtId,
      currentExpandedFoodCourt,
      switchRestaurant,
      touchFeature,
      filterDialogState
    } = this.state;

    let currentFoodCourtDetails;
    for (let i = 0; i < userFoodCourts.length; i++) {
      if (currentFoodCourtId === userFoodCourts[i].id) {
        currentFoodCourtDetails = userFoodCourts[i];
        break;
      }
    }
    let globalSearchShow = false;
    let restSearchShow = false;
    const pathnameSplit = location.pathname.split("/");
    if (
      pathnameSplit[1] === "dashboard" &&
      pathnameSplit[2] === "restaurants"
    ) {
      globalSearchShow = true;
    }
    if (pathnameSplit[1] === "restaurant") {
      restSearchShow = true;
    }
    let showLogo = pathnameSplit[1] === "dashboard";
    let foodcourtMessage = "";
    let foodcourtValue = (((foodCourtDetails || {}).extras || {}).extras || {})
      .short_fc_name;
    if (foodcourtValue) foodcourtMessage = `You are at: ${foodcourtValue}`;

    const { extras } = foodCourtSettings.settings || {};
    const { hideLogout } = extras || {};

    return (
      <Fragment>
        <div onClick={closeAllDialogs}>
          <Hidden only={["md", "lg", "xl"]}>
            <AppBar
              onClick={e => e.stopPropagation()}
              classes={{
                root: classes.appBarRoot
              }}
              className={classes.appBar}
              // style={{ zIndex: this.state.openDrawer ? "9999" : "1201" }}
            >
              <Toolbar style={{ padding: 0 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100vw"
                  }}
                >
                  <Grid container>
                    <Grid item>
                      {/* {this.isRestaurant() ? (
                      <IconButton
                        aria-label="back"
                        onClick={this.gotoDashboard}
                        className={classes.navIcon}
                        disableRipple={true}
                      >
                        <BackIcon />
                      </IconButton>
                    ) : ( */}
                      <IconButton
                        aria-label="open drawer"
                        onClick={this.handleDrawerToggle}
                        className={classes.navIcon}
                        style={{
                          fontSize: "34px",
                          paddingTop: foodcourtMessage && "3px"
                        }}
                        disableRipple={true}
                      >
                        <MenuIcon />
                      </IconButton>
                      {/* )} */}
                      {/* <img
                    src={foodbookLogo}
                    className={classes.Logo}
                    alt="FoodBook"
                  /> */}
                      <p
                        style={{
                          display: "inline-block",
                          position: "absolute",
                          top: "50%",
                          transform: "translateY(-50%)",
                          margin: "0px",
                          color: "#fff"
                        }}
                      >
                        {this.getLocationTitle(location)}
                      </p>
                      {/* {showLocation && (
                      <IconButton
                        className={classes.navIcon}
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "10px"
                        }}
                        onClick={this.selectFoodCourt}
                      >
                        <LocationIcon />
                      </IconButton>
                    )} */}
                    </Grid>
                    <Grid item container xs style={{ position: "relative" }}>
                      {showLogo && !searchBarShow && (
                        <React.Fragment>
                          {!showLocation && (
                            <img
                              src={FoodBookLogo}
                              className={classes.Logo}
                              alt="FoodBook"
                            />
                          )}
                        </React.Fragment>
                      )}
                      <Grid container item xs>
                        {globalSearchShow && (
                          <GlobalSearch
                            showLogo={true}
                            searchBarShow={searchBarShow}
                            showLocation={showLocation}
                            hideLocationChange={hideLocationChange}
                            searchItemClick={this.searchItemClick}
                            searchText={searchText}
                            searchTextOnChange={this.searchTextOnChange}
                            clearSearch={this.clearSearch}
                            classNames={classes}
                            restaurantName={restaurantName}
                          />
                        )}
                        {restSearchShow && (
                          <RestSearch
                            showLogo={true}
                            searchBarShow={searchBarShow}
                            showLocation={showLocation}
                            hideLocationChange={hideLocationChange}
                            searchText={searchText}
                            searchTextOnChange={this.searchTextOnChange}
                            clearSearch={this.clearSearch}
                            classes={classes}
                            switchRestaurant={this.switchRestaurant}
                            restaurantName={restaurantName}
                          />
                        )}
                      </Grid>
                      {!searchBarShow && (globalSearchShow || restSearchShow) && (
                        <React.Fragment>
                          <Grid item>
                            <IconButton
                              className={classes.navIcon}
                              onClick={this.showSearchBar}
                              style={{
                                paddingTop: foodcourtMessage && "10px"
                              }}
                            >
                              <SearchIcon />
                            </IconButton>
                          </Grid>
                        </React.Fragment>
                      )}
                      {!searchBarShow && isDashboard && (
                        <Grid item>
                          <IconButton
                            className={classes.navIcon}
                            style={{ paddingTop: foodcourtMessage && "10px" }}
                          >
                            <FeedbackIndicator isMobile={true} />
                          </IconButton>
                        </Grid>
                      )}
                      {/* {showHome && (
                        <React.Fragment>
                          <Grid item>
                            <IconButton
                              className={classes.navIcon}
                              onClick={this.selectFoodCourt}
                            >
                              <LocationIcon />
                            </IconButton>
                          </Grid>
                        </React.Fragment>
                      )} */}
                      {!searchBarShow && !hideSearchBar && (
                        <Grid item>
                          <IconButton
                            className={classes.navIcon}
                            aria-owns={filterAnchorEl ? "filter-menu" : null}
                            aria-haspopup="true"
                            style={{
                              position: "relative",
                              paddingTop: foodcourtMessage && "10px"
                            }}
                            onClick={this.handleFilterMenu}
                          >
                            <img
                              className={FilterStyle}
                              style={{
                                height: this.isFilterSelected()
                                  ? "24px"
                                  : "20px"
                              }}
                              src={
                                this.isFilterSelected()
                                  ? SelectedFilter
                                  : EmptyFilter
                              }
                            />
                          </IconButton>
                        </Grid>
                      )}
                      {!searchBarShow && showHome && (
                        <React.Fragment>
                          <Grid item>
                            <IconButton
                              className={classes.navIcon}
                              onClick={this.selectFoodCourt}
                              style={{ paddingTop: foodcourtMessage && "10px" }}
                            >
                              <LocationIcon />
                            </IconButton>
                          </Grid>
                        </React.Fragment>
                      )}
                      {touchFeature && (
                        <React.Fragment>
                          <EventListener
                            target="document"
                            onTouchMove={this.triggerOnTouchEvent}
                          />
                          <Backdrop open={true} />
                        </React.Fragment>
                      )}
                    </Grid>

                    {showHome && (
                      <Grid item xs={12} className={FoodcourtLabel}>
                        {/* <p style={{ margin: "0px" }}>
                          {foodcourtMessage}
                        </p> */}
                        <Typography variant="body2" style={{ color: "white" }}>
                          {foodcourtMessage}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                  {/* <div style={{ display: "flex" }}>
                  <IconButton
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                  >
                    <OrderHistoryIcon />
                  </IconButton>
                  <IconButton
                    aria-haspopup="true"
                    onClick={this.handleMenu}
                    color="inherit"
                  >
                    to be replaced with filter icon
                    <FavoriteIcon />
                  </IconButton>
                </div> */}
                </div>
              </Toolbar>
            </AppBar>
          </Hidden>
          <Hidden only={["xs", "sm"]}>
            <br />
            {pageLocation === "Settings" ? (
              <SettingsDesktopHeader logoutHandler={this.logoutHandler} />
            ) : (
              <DashboardDesktopHeader
                hideSearchBar={hideSearchBar}
                selectFoodCourt={this.selectFoodCourt}
                logoutHandler={this.logoutHandler}
                disableLocationSelection={disableLocationSelection}
                searchItemClick={this.searchItemClick}
              />
            )}
          </Hidden>
          <Hidden only={["md", "lg", "xl"]}>
            <Drawer
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={this.state.openDrawer}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper
              }}
              ModalProps={{
                keepMounted: true // Better open performance on mobile.
              }}
            >
              <DrawerContent
                classes={classes}
                history={this.props.history}
                close={this.handleDrawerToggle}
                logoutHandler={this.logoutHandler}
                userDetails={userDetails}
                hideLogout={hideLogout}
                foodCourtDetails={this.props.foodCourtDetails}
              />
            </Drawer>
          </Hidden>
          <Dialog
            open={dialogState}
            onClose={this.handleDialogClose}
            aria-labelledby="simple-dialog-title"
            PaperProps={{ style: { width: "100%", maxWidth: "350px" } }}
          >
            <DialogTitle
              id="simple-dialog-title"
              disableTypography
              style={{ backgroundColor: "#F37020", padding: "16px 24px" }}
            >
              <Typography
                variant="subheading"
                style={{ backgroundColor: "#F37020", color: "white" }}
              >
                Select Food Court
              </Typography>
            </DialogTitle>
            <div style={DialogStyles.RestaurantDialog}>
              {currentFoodCourtDetails && (
                <FoodCourtCard
                  data={this.props}
                  key={currentFoodCourtDetails.id}
                  currentOpenPanel={currentExpandedFoodCourt}
                  onChange={this.handlePanel}
                  dialogStyles={DialogStyles}
                  item={currentFoodCourtDetails}
                />
              )}
              {userFoodCourts.length > 1 && (
                <Typography
                  variant="subheading"
                  style={DialogStyles.OtherLocation}
                >
                  Other Location(s)
                </Typography>
              )}
              {userFoodCourts.map(item => {
                if (item.id === currentFoodCourtId) {
                  return null;
                }

                return (
                  <FoodCourtCard
                    data={this.props}
                    clickHandler={this.handleListItemClick}
                    currentOpenPanel={currentExpandedFoodCourt}
                    onChange={this.handlePanel}
                    key={item.id}
                    dialogStyles={DialogStyles}
                    item={item}
                  />
                );
              })}
              {userFoodCourts.length === 0 && (
                <MuiThemeProvider theme={foodbookTheme}>
                  <LinearProgress />
                </MuiThemeProvider>
              )}
            </div>
          </Dialog>
          {switchRestaurant && (
            <SwitchRestaurantModal
              open={switchRestaurant}
              handleClose={this.switchRestaurant}
              restList={restaurants}
              preorder={this.props.preorder}
            />
          )}
        </div>
        <FilterDropdown
          open={filterDialogState}
          closeMenu={this.handleFilterMenuClose}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let otherStates = {};
  if (!ownProps.hideSearchBar) {
    otherStates = {
      isBuffet: state.currentRestaurantDetails.restextras.isbuffet,
      restaurantIsAlive: state.currentRestaurantDetails.resturantalive,
      servingTime: state.currentRestaurantDetails.servingtime,
      restaurantName: state.currentRestaurantDetails.restextras.name
    };
  }

  return {
    foodCourtDetails: state.currentFoodCourtDetails,
    restaurants: state.restaurantsList,
    userDetails: state.userDetails,
    immutableMenuList: state.immutableMenuList,
    immutableSubMenu: state.immutableSubMenu,
    filters: state.filters,
    searchText: state.searchText,
    searchId: state.searchId,
    selectedDate: state.selectedDate,
    currentSession: state.currentSession,
    allergens: state.allergens,
    immutableAllergens: state.immutableAllergens,
    foodCourtSettings: state.foodCourtSettings || {},
    slotShow: state.slotShow,
    ...otherStates
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearUserDetails: () => {
      dispatch(clearUserDetails());
    },
    changeFilter: (centralData, options) => {
      dispatch(setFilters(options.filters));
      dispatch(reduceMenuList(centralData, options));
    },
    searchForText: (data, options) => {
      dispatch(reduceMenuList(data, options));
      dispatch(setSearchText(options.searchText));
      dispatch(setSearchNotify(options.searchId));
    },
    clearSearchText: (data, options) => {
      dispatch(reduceMenuList(data, options));
      dispatch(clearSearchText());
    },
    resetApp: () => {
      dispatch({ type: "PURGE_EVERYTHING" });
    },
    storeFoodCourtsList: list => {
      dispatch(storeFoodCourtsList(list));
    },
    setAlertPopup: alertMessage => {
      dispatch(setErrorMessage(alertMessage));
    },
    clearFoodNRecURLS: () => dispatch(clearFoodNRecURLS({})),
    clearSearchNotify: () => dispatch(clearSearchNotify()),
    storeFoodCourtDetails: data => dispatch(storeFoodCourtDetails(data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(classes, { withTheme: true })(AppBarAndDrawer))
);



// WEBPACK FOOTER //
// ./src/components/AppBarAndDrawer.js